import { makeAutoObservable } from "mobx";
import type { SolutionModel } from "../types/solution";

const SYSTEM_SOLUTION_SLUG = "system";

const isSelectableSolution = (solution: SolutionModel): boolean =>
  solution.slug !== SYSTEM_SOLUTION_SLUG &&
  !solution.hidden &&
  !solution.delete_date;

export class SolutionStore {
  list: SolutionModel[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setList(solutions: SolutionModel[]): void {
    this.list = solutions.filter(isSelectableSolution);
  }
}
